import { createReducer } from "reduxsauce";

import ReducerRegister from "../../../ReducerRegister";
import UnitPreviewService from "../../../../services/screens/admin/homework/UnitPreviewService";
import FeedbackSuggestionService from "../../../../mobile/services/screens/me/FeedbackSuggestionService";
import { ActionTypes } from "../../../actionTypes/screens/admin/homework/UnitPreviewActionTypes";
import AsyncActionReducers from "../../../AsyncActionReducers";
import UIDs from "../../../../UIDs";

const uid = UIDs.screens.admin.homework.unitpreview;

//
// Actions
//
const Actions = {
    loadScreenViewAsync: (vo, unit) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC });

            UnitPreviewService.loadScreenView(
                vo,
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response, unit));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: (data, unit) => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data,
        unit,
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),

    editUnitAnswer: (id) => ({
        type: ActionTypes.EDIT_UNIT_ANSWER,
        id,
    }),

    viewUnitAnswer: (id) => ({
        type: ActionTypes.VIEW_UNIT_ANSWER,
        id,
    }),

    showReportError: (show) => ({
        type: ActionTypes.SHOW_REPORT_ERROR,
        show,
    }),

    saveReferenceAnswerAsync: (vo) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.SAVE_REFERENCE_ANSWER_ASYNC, vo });

            UnitPreviewService.saveUnitReferenceAnswer(
                vo,
                response => {
                    dispatch(Actions.saveReferenceAnswerSuccess(vo.id, response));
                },
                error => {
                    dispatch(Actions.saveReferenceAnswerFailure(error));
                }
            );
        };
    },

    saveReferenceAnswerSuccess: (id, data) => ({
        type: ActionTypes.SAVE_REFERENCE_ANSWER_SUCCESS,
        parentType: ActionTypes.SAVE_REFERENCE_ANSWER_ASYNC,
        id,
        data,
    }),

    saveReferenceAnswerFailure: error => ({
        type: ActionTypes.SAVE_REFERENCE_ANSWER_FAILURE,
        parentType: ActionTypes.SAVE_REFERENCE_ANSWER_ASYNC,
        error
    }),

    reportErrorAsync: (vo) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.REPORT_ERROR_ASYNC, vo });

            FeedbackSuggestionService.reportUnitError(
                vo,
                response => {
                    dispatch(Actions.reportErrorSuccess(response));
                },
                error => {
                    dispatch(Actions.reportErrorFailure(error));
                }
            );
        };
    },

    reportErrorSuccess: (data) => ({
        type: ActionTypes.REPORT_ERROR_SUCCESS,
        parentType: ActionTypes.REPORT_ERROR_ASYNC,
        data,
    }),

    reportErrorFailure: error => ({
        type: ActionTypes.REPORT_ERROR_FAILURE,
        parentType: ActionTypes.REPORT_ERROR_ASYNC,
        error
    }),
};

//
// Initial State
//
const INITIAL_STATE = {
    editUnitAnswer: null,
    viewUnitAnswer: null,
    showReportError: false,
};

//
// Reducers
//
const loadScreenViewSuccessPostReducer = (state, { data, unit }) => {
    return { ...state, viewUnitAnswer: unit };
};

const editUnitAnswerReducer = (state, { id }) => {
    let unit = state.units.find(u => u.id === id);
    return { ...state, editUnitAnswer: unit };
};

const viewUnitAnswerReducer = (state, { id }) => {
    let unit = state.units.find(u => u.id === id);
    return { ...state, viewUnitAnswer: unit };
};

const showReportErrorReducer = (state, { show }) => {
    return { ...state, showReportError: show };
};

// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.EDIT_UNIT_ANSWER]: editUnitAnswerReducer,
    [ActionTypes.VIEW_UNIT_ANSWER]: viewUnitAnswerReducer,
    [ActionTypes.SHOW_REPORT_ERROR]: showReportErrorReducer,
    [ActionTypes.SAVE_REFERENCE_ANSWER_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.SAVE_REFERENCE_ANSWER_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.SAVE_REFERENCE_ANSWER_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.REPORT_ERROR_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.REPORT_ERROR_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.REPORT_ERROR_FAILURE]: AsyncActionReducers.failureReducer,
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
